import { render } from "./MarcheViews.vue?vue&type=template&id=586cb2f7&scoped=true"
import script from "./MarcheViews.vue?vue&type=script&lang=js"
export * from "./MarcheViews.vue?vue&type=script&lang=js"

import "./MarcheViews.vue?vue&type=style&index=0&id=586cb2f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586cb2f7"]])

export default __exports__